import React from 'react'
import {
  ShopContext,
  ModalManagerContext,
  FlashContext,
  useFlash,
  SetupAppContent,
  AppContentContext,
  SetupSlerpShop,
  SetupModal,
  LoaderContext,
  SetupLoader,
  QueryParamsContext,
  SetupQueryParamsContext,
  CheckoutContextProvider,
  ConsumerCartProvider
} from 'shop/hooks'
import ThemeProvider from 'shop/theme'
import Theme from 'shop/theme/types'

interface ShopProps {
  theme?: Theme
  children?: React.ReactNode
}

export const GlobalContext = ({ theme, children }: ShopProps) => {
  // get the query params context before render so it can be passed into the Shop Context,
  // so we can pass variables into the partner query from the query params on load.
  const queryContext = SetupQueryParamsContext()

  return (
    <QueryParamsContext.Provider value={queryContext}>
      <ShopContext.Provider
        value={SetupSlerpShop(queryContext.searchQueryParams)}
      >
        <FlashContext.Provider value={useFlash()}>
          <ModalManagerContext.Provider value={SetupModal()}>
            <AppContentContext.Provider value={SetupAppContent()}>
              <ConsumerCartProvider>
                <CheckoutContextProvider>
                  <LoaderContext.Provider value={SetupLoader()}>
                    <ThemeProvider theme={theme}>{children}</ThemeProvider>
                  </LoaderContext.Provider>
                </CheckoutContextProvider>
              </ConsumerCartProvider>
            </AppContentContext.Provider>
          </ModalManagerContext.Provider>
        </FlashContext.Provider>
      </ShopContext.Provider>
    </QueryParamsContext.Provider>
  )
}

export default GlobalContext
